import { Component, Inject, OnInit } from '@angular/core';
import { NewPmeAdminComponent } from '../../reportes/components/new-pme-admin/new-pme-admin.component';

@Component({
  selector: 'app-simulacion-new-pme',
  templateUrl: './simulacion-new-pme.component.html',
  styleUrls: ['./simulacion-new-pme.component.css']
})
export class SimulacionNewPmeComponent implements OnInit {

  constructor(
    @Inject(NewPmeAdminComponent) private parent: NewPmeAdminComponent
  ) { }

  ngOnInit(): void {
  }

  volver(){
    this.parent.ngOnInit();
  }
}